import { cloneDeep } from 'lodash'

export default class ImageCrud {
	constructor (init = {}) {
		if (!init) return

		this.id = init.hasOwnProperty('id') ? init.id : null
		this.default = init.hasOwnProperty('default') ? init.default : ''
		this.original = init.hasOwnProperty('original') ? (init.original || this.default) : this.default
		this.small = init.hasOwnProperty('small') ? (init.small || this.default) : this.default
		this.medium = init.hasOwnProperty('medium') ? (init.medium || this.default) : this.default
		this.large = init.hasOwnProperty('large') ? (init.large || this.default) : this.default
	}

	get isValid () {
		return !!this.original
	}

	/**
	 * Клонирует текущий объект и возвращает его клон
	 * @return {ImageCrud}
	 */
	clone () {
		const cloneObj = cloneDeep(this)
		// eslint-disable-next-line no-proto
		cloneObj.__proto__ = ImageCrud.prototype

		return cloneObj
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/ImageCrud.class.js